import { Component, OnInit, Input } from '@angular/core';
import { UtilsService } from 'src/app/services/utils.service';

@Component({
  selector: 'app-barra-titulo',
  templateUrl: './barra-titulo.component.html'
})
export class BarraTituloComponent implements OnInit {
  @Input()
  modulo: any = {};
  icono: any = '';

  constructor(private utils: UtilsService) {
  }

  ngOnInit(): void {
    this.icono = this.utils.validarString(this.modulo.icono) ? this.modulo.icono : this.modulo.menu.icono;
  }

}
